import { TransactionServices } from '@/services/transaction.buyer.service'

const state = {
  loading: false,
  dialog: false,
  overlay: false,
  trxpembelian: [],
  sumbuy: [0, 0],
  totaltrxpembelian: 0
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  getTrxBuy ({ commit }, opt) {
    commit('setloading', true)
    TransactionServices.getTrxBuy(opt).then(value => {
      commit('setloading', false)
      commit('setdata', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getSumBuy ({ commit }) {
    commit('setloading', true)
    TransactionServices.getSumBuy().then(value => {
      commit('setloading', false)
      commit('setdatasumbuy', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setdata (state, s) {
    state.trxpembelian = []
    state.trxpembelian = s.data.content
    state.totaltrxpembelian = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setdatasumbuy (state, s) {
    state.sumbuy = []
    state.sumbuy = s.data
    state.loading = false
    state.overlay = false
  }
}

export const TrxPembelian = {
  namespaced: true,
  state,
  actions,
  mutations
}
